import { FormControlReadOnly, Layout, Page } from "@fdoh/health-ui-react";
import { useData } from "../../../hooks";
import { ApplicationDetails, ApplicationDetailsProps } from "./ApplicationDetails.types";
import "../../../../css/custom.css";
import flSealLogo from "../../../../img/Florida_Seal.png"


// TODO: Add error handling

const ApplicationDetailsPage = (props: ApplicationDetailsProps) => {
  const applicationData = useData<ApplicationDetails>('Application/'+ props.id);
    return applicationData ? (
        // <div className="page-body">
        // <div className="container-xl">

        <Page.Body>
            <Layout.Container>
               
                <div className="accordion" id="accordion-example">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="heading-1">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="false">
                                <div className="col-md-12 col-lg-1">
                                </div>
                                <div className="col-md-12 col-lg-5">
                                    AP #      {applicationData.apnumber}

                                </div>
                                <div className="col-md-12 col-lg-6 ms-auto">
                                    Property Address :  {applicationData.propertyStreetAddress + ", " + applicationData.propertyCity + ", " + applicationData.propertyState + ", " + applicationData.propertyZipCode}
                                </div>

                            </button>
                        </h2>
                        <div id="collapse-1" className="accordion-collapse collapse" data-bs-parent="#accordion-example">
                            <div className="accordion-body pt-0">
                                <div className="row">
                                    <div className="col col-md-1">
                                        <img src={flSealLogo} alt="Florida Seal" className="florida-seal" />
                                    </div>
                                    <div className="col col-md-11">
                                        <div className="container-xl">
                                            <div className="datagrid datagridcolor">
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">PERMIT #</div>
                                                    <div className="datagrid-content">{applicationData.permitNumber}</div>
                                                </div>
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">PROPERTY ID</div>
                                                    <div className="datagrid-content">{applicationData.propertyNumber}</div>
                                                </div>
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">APPLICANT NAME</div>
                                                    <div className="datagrid-content">{applicationData.applicantName}</div>
                                                </div>
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">AGENT NAME</div>
                                                    <div className="datagrid-content">{applicationData.agentName}</div>
                                                </div>
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">SUBDIVISION</div>
                                                    <div className="datagrid-content">
                                                        {applicationData.subDivision}
                                                    </div>
                                                </div>
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">LOT</div>
                                                    <div className="datagrid-content">{applicationData.lot}</div>
                                                </div>
                                                <div className="datagrid-item">
                                                    <div className="datagrid-title">BLOCK</div>
                                                    <div className="datagrid-content">
                                                        {applicationData.block}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </Layout.Container>
        </Page.Body>

        //   </div>
        // </div>
    ) :
        null;
};

export default ApplicationDetailsPage;